import axios from "axios";

import Navbar from './Navbar'
import Topbar from './Topbar'

import {useState, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {APIURL} from './config'
import Loading from './Loading'

function Tarefas() {

    const [results, setResults] = useState()

    const [origem, setOrigem] = useState()
    const [status, setStatus] = useState()
    const [numero, setNumero] = useState()
    const [tipo, setTipo] = useState()

    const [mydisplay, setMydisplay] = useState('none') 

    const navigate= useNavigate()

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
        listresume( sessionStorage.getItem("tokeninovacao"))
    }, [])

    const listresume= async (mytoken) => {
        
        try {
            const res = await axios.post(`${APIURL}/User/Tasks`, {TOKEN :sessionStorage.getItem("tokeninovacao")});
            if (res.data) {
                setResults(res.data);
            }
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  



    const doFilter= async (e) => {
        e.preventDefault()
        
        try {
            const res = await axios.post(`${APIURL}/User/Tasks`, {TOKEN : sessionStorage.getItem("tokeninovacao"), Status: status, Number: numero, Type: tipo});
            if (res.data) {
                setResults(res.data);
                setMydisplay('none')
            } else {
                alert("nada encocntrado")
            }
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    function mostrafiltro() {
        if (mydisplay == 'block') {
            setMydisplay('none')
        }else {
            setMydisplay('block')
        }
    }

    function retornadata(data) {

        //alert(data)
        let myday
        let mymonth
        let myyear
        if (isNaN(new Date(data).getDate())) {
            //não converteu direito
            myday = data.substring(0, 2)
            mymonth = data.substring(3, 5)
            myyear = data.substring(6,10)
        } else {
            myday = new Date(data).getDate()
            mymonth = new Date(data).getMonth()+1
            myyear = new Date(data).getFullYear()
        }
        const mydate = myday + '/' + mymonth + '/' + myyear
        return mydate
    }

    return (

       <div>
            <Topbar />
            {results ?
                <div className="container py-4 px-2 px-md-5">
                    <div className="d-flex justify-content-between align-items-center ">
                        <div className="h4 mb-0">Tarefas</div>
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <div>
                                <button onClick={()=> mostrafiltro()} className="btn btn-success " ><i className="bi bi-filter fs-6 "></i></button>
                            </div>
                            
                        </div>
                    </div>
                    
                        

                    <div className=" bg-white p-3 mt-4 shadow-sm" style={{display: mydisplay}}>
                        <p  className="mb-2" >Selecione o filtro:</p>
                        
                        <form onSubmit={(e)=> doFilter(e)} role="form" >
                            <div className="row g-3 mb-3">
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Origem: </label> 
                                    <select  onChange={(e)=> setOrigem(e.target.value)} className="form-control">
                                        <option value=""></option>
                                        <option value="minhas">Minhas Tarefas</option>
                                        <option value="todas">Todas as Tarefas</option>
                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Status: </label> 
                                    <select  onChange={(e)=> setStatus(e.target.value)} className="form-control">
                                        <option value=""></option>
                                        <option value="em Aberto">em Aberto</option>
                                        <option value="em Andamento">em Andamento</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Terminado">Terminado</option>
                                        <option value="Pausado">Pausado</option>
                                        <option value="Planejado">Planejado</option>
                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Tipo: </label> 
                                    <select  onChange={(e)=> setTipo(e.target.value)} className="form-control">
                                        <option value=""></option>
                                        <option value="Validação">Validação</option>
                                        <option value="Análise">Análise</option>
                                        <option value="Aprovação">Aprovação</option>
                                        <option value="Resultados">Resultados</option>

                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Número: </label> 
                                    <input type="text" className="form-control" required="" onChange={(e)=> setNumero(e.target.value)} />
            
                                </div>
                            </div> 
                            
                            <button className="form-group btn btn-sm btn-success" type="submit"><strong>Filtrar</strong></button>
                        </form>
                    </div>
                        
                                    
                    <table className="table table-striped mt-4">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Ideia</th>
                            <th>Fase</th>
                            <th>Criada em</th>
                            <th>Prazo</th>
                            <th>Status</th>
                            
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        
                            {results &&  results.map((item, i) => {
                                return(

                                        <tr key={item.ID}>
                                            <td>{item.NUMERO} - {item.ID} - {item.PROCESSO_SOLICITANTE} - {item.CLIENTE}</td>
                                            <td>{item.PROCESSO_NOME}</td>
                                            <td>{item.TIPO}</td>
                                            <td>{retornadata(item.DATA_ABERTURA)}</td>
                                            <td>{retornadata(item.DATA_LIMITE)}</td>
                                            <td>{item.STATUS}</td>
                                            
                                            <td><Link to="/tarefaunica" state={{processo_id: item.PROCESSO_ID, processo_numero: item.NUMERO}}><i className="bi bi-chevron-right fs-6 minhafonte"></i></Link></td>
                                        </tr>
                                
                                )
                            })}

                        </tbody>
                    </table>

 
                </div>

            :
                <Loading />
            }
        </div>

        
      );
    }
    
    export default Tarefas;
